import React, { useState } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMapEvents } from "react-leaflet";
import "leaflet/dist/leaflet.css";

const LocationSelector = ({ onLocationSelect }) => {
  const [position, setPosition] = useState({ lat: 20.5937, lon: 78.9629 }); // Default: India
  const [manualLat, setManualLat] = useState("");
  const [manualLon, setManualLon] = useState("");

  // Function to handle clicking on the map
  function LocationMarker() {
    useMapEvents({
      click(e) {
        const newPosition = { lat: e.latlng.lat, lon: e.latlng.lng };
        setPosition(newPosition);
        onLocationSelect(newPosition);
      },
    });

    return position.lat ? (
      <Marker position={[position.lat, position.lon]}>
        <Popup>Selected: {position.lat}, {position.lon}</Popup>
      </Marker>
    ) : null;
  }

  // Handle manual latitude and longitude input
  const handleManualInput = () => {
    if (manualLat && manualLon) {
      const newPosition = { lat: parseFloat(manualLat), lon: parseFloat(manualLon) };
      setPosition(newPosition);
      onLocationSelect(newPosition);
    }
  };

  return (
    <div>
      <h2>Select Location</h2>
      <div>
        <input
          type="number"
          placeholder="Latitude"
          value={manualLat}
          onChange={(e) => setManualLat(e.target.value)}
        />
        <input
          type="number"
          placeholder="Longitude"
          value={manualLon}
          onChange={(e) => setManualLon(e.target.value)}
        />
        <button onClick={handleManualInput}>Search</button>
      </div>

      <MapContainer center={[position.lat, position.lon]} zoom={5} style={{ height: "400px", width: "100%" }}>
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        <LocationMarker />
      </MapContainer>
    </div>
  );
};

export default LocationSelector;
